module.exports = __webpack_public_path__ + "static/media/glitter.6d416cd8.m4a";